(function () {
  if (window._productCardVivaLoaded) return;
  window._productCardVivaLoaded = true;

  var swatchImageCache = {};
  var productCache = {};
  var failedHandles = new Set();

  // ── Declarar observer aquí para poder usarlo en removeOrphanSwatch ───────
  var swatchObserver;
  var swatchDebounce;
  var swatchRunning = false;

  function escapeHtml(value) {
    if (value == null) return '';
    return String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function withImageWidth(url, width) {
    if (!url) return '';
    var normalized = url.replace(/^\/\//, 'https://');
    return normalized + (normalized.indexOf('?') !== -1 ? '&' : '?') + 'width=' + width;
  }

  function moneyWithoutTrailingZeros(cents) {
    var moneyFormat = document.querySelector('[data-money-format]')?.getAttribute('data-money-format') ||
      (window.themeVariables && window.themeVariables.settings && window.themeVariables.settings.moneyFormat) ||
      '{{amount}} €';

    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      var formatted = window.Shopify.formatMoney(cents, moneyFormat);
      return formatted;
    }

    var amount = (cents / 100).toFixed(2);
    return amount.replace('.', ',') + ' €';
  }

  function parseTitle(fullTitle) {
    var parts = (fullTitle || '').split('|');
    var title = (parts[0] || '').trim();
    var color = (parts.slice(1).join('|') || title).trim();
    return { title: title, color: color };
  }

  function getGenderParam() {
    try {
      var gender = sessionStorage.getItem('nd_collection_gender');
      return gender ? '?gender=' + encodeURIComponent(gender) : '';
    } catch (e) {
      return '';
    }
  }

  function buildProductUrl(handle) {
    return '/products/' + handle + getGenderParam();
  }

  function fetchProduct(handle) {
    if (productCache[handle]) {
      return Promise.resolve(productCache[handle]);
    }

    return fetch('/products/' + handle + '.js')
      .then(function (response) {
        if (!response.ok) {
          throw new Error('HTTP ' + response.status + ' for handle: ' + handle);
        }
        return response.json();
      })
      .then(function (productData) {
        productCache[handle] = productData;
        return productData;
      });
  }

  function applySwatchImage(spanEl, src) {
    if (!spanEl || !spanEl.parentNode) return;

    var img = document.createElement('img');
    img.src = src;
    img.alt = '';
    img.className = 'product-card__swatch__image';
    img.loading = 'lazy';

    spanEl.parentNode.replaceChild(img, spanEl);
  }

  // ✅ FIX — desconectar observer mientras se elimina para cortar el bucle
  function removeOrphanSwatch(handle) {
    if (swatchObserver) swatchObserver.disconnect();

    document.querySelectorAll(
      '.product-card__swatch[data-handle="' + handle + '"]'
    ).forEach(function (swatchEl) {
      var item = swatchEl.closest('.baslide__item');
      if (item) item.remove();
    });

    // Reconectar después de un tick para que los removes no disparen el observer
    setTimeout(function () {
      if (swatchObserver) {
        swatchObserver.observe(document.body, { childList: true, subtree: true });
      }
    }, 0);
  }

  function loadSwatchImages() {
    var pendingSwatches = document.querySelectorAll('.product-card__swatch__loading');
    if (!pendingSwatches.length) return;

    var handlesToFetch = {};

    pendingSwatches.forEach(function (el) {
      var swatchEl = el.closest('[data-handle]');
      if (!swatchEl) return;

      var handle = swatchEl.dataset.handle;
      if (!handle) return;

      if (failedHandles.has(handle)) return;

      if (swatchImageCache[handle]) {
        applySwatchImage(el, swatchImageCache[handle]);
        return;
      }

      if (!handlesToFetch[handle]) handlesToFetch[handle] = [];
      handlesToFetch[handle].push(el);
    });

    Object.keys(handlesToFetch).forEach(function (handle) {
      fetchProduct(handle)
        .then(function (data) {
          var imgSrc = null;
          if (data.featured_image) {
            imgSrc = data.featured_image;
          } else if (data.images && data.images.length) {
            imgSrc = data.images[0];
          }

          if (!imgSrc) return;

          var sized = withImageWidth(imgSrc, 200);
          swatchImageCache[handle] = sized;

          handlesToFetch[handle].forEach(function (el) {
            applySwatchImage(el, sized);
          });
        })
        .catch(function (error) {
          failedHandles.add(handle);
          removeOrphanSwatch(handle);
          console.warn('[Product card swatch] Handle no disponible, eliminado:', handle, error.message);
        });
    });
  }

  function setActiveSwatch(card, swatch) {
    card.querySelectorAll('.product-card__swatch').forEach(function (item) {
      item.classList.remove('product-card__swatch--active');
    });
    swatch.classList.add('product-card__swatch--active');
  }

  function updateCardLinks(card, handle) {
    var href = buildProductUrl(handle);

    card.querySelectorAll('a[href*="/products/"]').forEach(function (link) {
      link.href = href;
    });

    card.querySelectorAll('.product-card__thumbnail').forEach(function (link) {
      link.setAttribute('data-url', '/products/' + handle);
    });
  }

  function updateCardTitle(card, productData) {
    var titleParts = parseTitle(productData.title);
    var titleAnchor = card.querySelector('.product-card__title a');
    var colorNode = card.querySelector('.product-card-color');

    if (titleAnchor) {
      titleAnchor.innerHTML =
        escapeHtml(titleParts.title) +
        '<span class="color_in_title">| ' +
        escapeHtml(titleParts.color) +
        '</span>';
    }

    if (colorNode) {
      colorNode.textContent = titleParts.color;
    }

    var activeSwatch = card.querySelector('.product-card__swatch--active');
    if (activeSwatch) {
      activeSwatch.setAttribute('title', titleParts.color);
      activeSwatch.setAttribute('data-color', titleParts.color);
    }
  }

  function updateCardPrices(card, productData) {
    var priceList = card.querySelector('.ProductItem__PriceList');
    if (!priceList) return;

    var discountLabel = card.getAttribute('data-discount-label') || 'Discount';
    var hasCompare = productData.compare_at_price && productData.compare_at_price > productData.price;
    var discount = hasCompare
      ? Math.round(((productData.compare_at_price - productData.price) * 100) / productData.compare_at_price)
      : null;
    var priceHtml = '';

    if (hasCompare) {
      priceHtml +=
        '<span class="ProductItem__Price Price Price--highlight Text--subdued">' +
        escapeHtml(moneyWithoutTrailingZeros(productData.price)) +
        '</span>';
      priceHtml +=
        '<span class="ProductItem__Price Price Price--compareAt Text--subdued">' +
        escapeHtml(moneyWithoutTrailingZeros(productData.compare_at_price)) +
        '</span>';
    } else {
      priceHtml +=
        '<span class="ProductItem__Price Price Text--subdued">' +
        escapeHtml(moneyWithoutTrailingZeros(productData.price)) +
        '</span>';
    }

    if (discount) {
      priceHtml += '<div class="product-card__price-list-discount-percentage">-' + discount + '%</div>';
    }

    priceList.innerHTML = priceHtml;

    var badgeGroup = card.querySelector('.product-card__badges');
    if (!badgeGroup) return;

    var discountBadge = badgeGroup.querySelector('.discount__badge');
    if (discount) {
      if (!discountBadge) {
        discountBadge = document.createElement('div');
        discountBadge.className = 'product-card__badge discount__badge';
        badgeGroup.appendChild(discountBadge);
      }
      discountBadge.textContent = discountLabel + ' ' + discount + '%';
    } else if (discountBadge) {
      discountBadge.remove();
    }
  }

  function updatePrivadaBadge(card, productData) {
    var privadaContainer = card.querySelector('.product-card__badges-privada');
    if (!privadaContainer) return;

    var privadaLabel = card.getAttribute('data-privada-label') || 'Privada';
    var hasPrivada = (productData.tags || []).indexOf('TAG_Privada') !== -1;

    privadaContainer.setAttribute('data-product-id', productData.id);
    privadaContainer.setAttribute('data-has-privada-tag', hasPrivada ? 'true' : 'false');
    privadaContainer.innerHTML = hasPrivada
      ? '<div class="product-card__badge-privada">' + escapeHtml(privadaLabel) + '</div>'
      : '';

    var activeSwatch = card.querySelector('.product-card__swatch--active');
    if (activeSwatch) {
      activeSwatch.setAttribute('data-has-privada-tag', hasPrivada ? 'true' : 'false');
    }
  }

  function updateSizes(card, productData) {
    var sizeGroup = card.querySelector('.size-button__group');
    if (!sizeGroup) return;

    var sizesHtml = '';
    (productData.variants || []).forEach(function (variant) {
      sizesHtml +=
        '<label class="size-button' +
        (variant.available ? '' : ' size-button--unavailable') +
        '" data-block="size">';
      sizesHtml +=
        '<input type="radio" name="id" value="' +
        variant.id +
        '" data-available="' + (variant.available ? 'true' : 'false') + '">';
      sizesHtml +=
        '<div class="size-button__content"><span>EU</span><span>' +
        escapeHtml(variant.title) +
        '</span></div>';
      sizesHtml += '</label>';
    });

    sizeGroup.innerHTML = sizesHtml;

    var addButton = card.querySelector('.product-card-add-btn');
    if (addButton) {
      addButton.disabled = true;
      addButton.textContent = addButton.getAttribute('data-select-size-text') || addButton.textContent;
    }
  }

  function updateCarousel(card, productData) {
    var carousel = card.querySelector('.product-card__carousel');
    var wrapper = card.querySelector('.product-card__carousel .swiper-wrapper');
    if (!wrapper) return;

    var images = productData.images || [];
    if (!images.length) return;

    var href = buildProductUrl(productData.handle);
    var slidesHtml = '';

    images.forEach(function (imageUrl, index) {
      slidesHtml += '<div class="swiper-slide">';
      slidesHtml +=
        '<a href="' +
        escapeHtml(href) +
        '" data-url="/products/' +
        escapeHtml(productData.handle) +
        '" rel="nofollow" class="product-card__thumbnail AspectRatio AspectRatio--withFallback" style="--aspect-ratio: 1;">';
      slidesHtml +=
        '<img src="' +
        escapeHtml(withImageWidth(imageUrl, 2000)) +
        '" alt="" width="200" height="200" loading="' +
        (index === 0 ? 'eager' : 'lazy') +
        '" fetchpriority="' +
        (index === 0 ? 'high' : 'auto') +
        '">';
      slidesHtml += '</a>';
      slidesHtml += '</div>';
    });

    wrapper.innerHTML = slidesHtml;

    if (carousel && carousel.swiper) {
      carousel.swiper.update();
      carousel.swiper.slideTo(0, 0);
    }
  }

  function updateActiveSwatchThumb(card, productData) {
    var activeSwatch = card.querySelector('.product-card__swatch--active');
    if (!activeSwatch || !productData.featured_image) return;

    activeSwatch.innerHTML =
      '<img src="' +
      escapeHtml(withImageWidth(productData.featured_image, 200)) +
      '" alt="" class="product-card__swatch__image" loading="eager">';
  }

  function resetCardBis(card) {
    var bisContainer = card.querySelector('.card-bis');
    var addButton = card.querySelector('.product-card-add-btn');
    if (bisContainer) bisContainer.style.display = 'none';
    if (addButton) addButton.style.display = '';
  }

  function updatePreorderState(card, isPreorder) {
    var badgeGroup = card.querySelector('.product-card__badges');
    var addButton = card.querySelector('.product-card-add-btn');

    // Badge
    if (badgeGroup) {
      var preorderBadge = badgeGroup.querySelector('.product-card__badge--preorder');
      if (isPreorder) {
        var badgeLabel = card.getAttribute('data-preorder-badge-label') || 'Pre-sale';
        if (!preorderBadge) {
          preorderBadge = document.createElement('div');
          preorderBadge.className = 'product-card__badge product-card__badge--preorder';
          badgeGroup.appendChild(preorderBadge);
        }
        preorderBadge.textContent = badgeLabel;
      } else if (preorderBadge) {
        preorderBadge.remove();
      }
    }

    // Button
    if (addButton) {
      if (isPreorder) {
        addButton.classList.add('preorder-card-btn');
        addButton.setAttribute('data-is-preorder', 'true');
        var preorderBtnText = card.getAttribute('data-preorder-btn-text') || '';
        if (preorderBtnText) addButton.setAttribute('data-add-to-cart-text', preorderBtnText);
      } else {
        addButton.classList.remove('preorder-card-btn');
        addButton.setAttribute('data-is-preorder', 'false');
        var regularText = addButton.getAttribute('data-add-to-cart-text-regular') || '';
        if (regularText) addButton.setAttribute('data-add-to-cart-text', regularText);
      }
    }

    // Info texts
    var infoDiv = card.querySelector('.preorder-card-info');
    if (infoDiv) infoDiv.style.display = isPreorder ? '' : 'none';

    // Parent container (used by add-to-cart JS for cart property)
    var container = card.closest('[data-is-preorder]');
    if (container && container !== card) {
      container.setAttribute('data-is-preorder', isPreorder ? 'true' : 'false');
    }
  }

  function applyProductToCard(card, swatch, productData) {
    setActiveSwatch(card, swatch);
    card.setAttribute('data-handle', productData.handle);

    updateCardLinks(card, productData.handle);
    updateCardTitle(card, productData);
    updateCardPrices(card, productData);
    updatePrivadaBadge(card, productData);
    updateSizes(card, productData);
    updateCarousel(card, productData);
    updateActiveSwatchThumb(card, productData);
    resetCardBis(card);
  }

  document.addEventListener('click', function (event) {
    var swatch = event.target.closest('.product-card__swatch[data-handle]');
    if (!swatch) return;

    var card = swatch.closest('.product-card');
    if (!card) return;

    event.preventDefault();

    var handle = swatch.getAttribute('data-handle');
    if (!handle) return;

    if (card.getAttribute('data-handle') === handle) {
      setActiveSwatch(card, swatch);
      return;
    }

    card.classList.add('product-card--loading');

    fetchProduct(handle)
      .then(function (productData) {
        applyProductToCard(card, swatch, productData);
        var isPreorder = !!(window.ndPreorderMap && window.ndPreorderMap[productData.handle]);
        updatePreorderState(card, isPreorder);
      })
      .catch(function (error) {
        console.warn('[Product card swatch] Error changing swatch:', handle, error);
      })
      .finally(function () {
        card.classList.remove('product-card--loading');
      });
  });

  document.addEventListener('change', function (event) {
    var input = event.target;
    if (!input.matches('.product-card .size-button input[type="radio"]')) return;

    var card = input.closest('.product-card');
    if (!card) return;

    var addButton = card.querySelector('.product-card-add-btn');
    var bisContainer = card.querySelector('.card-bis');
    var isAvailable = input.getAttribute('data-available') !== 'false';

    if (isAvailable) {
      if (addButton) {
        var cartSVG = '<svg xmlns="http://www.w3.org/2000/svg" width="20px" height="20px" viewBox="0 0 32 32" xml:space="preserve"><style type="text/css">.st0{fill:none;stroke:#fff;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}</style><polygon class="st0" points="26,29 6,29 8,9 24,9 "/><path class="st0" d="M12,13V7c0-2.2,1.8-4,4-4h0c2.2,0,4,1.8,4,4v6"/></svg>';
        var addText = addButton.getAttribute('data-add-to-cart-text') || 'Add to Cart';
        addButton.style.display = '';
        addButton.disabled = false;
        addButton.innerHTML = cartSVG + '<span>' + addText + '</span>';
      }
      if (bisContainer) bisContainer.style.display = 'none';
    } else {
      if (addButton) addButton.style.display = 'none';
      if (bisContainer) {
        bisContainer.style.display = 'block';
        bisContainer.setAttribute('data-variant-id', input.value);
        var feedback = bisContainer.querySelector('.card-bis__feedback');
        if (feedback) { feedback.style.display = ''; feedback.textContent = ''; feedback.className = 'card-bis__feedback'; }
        bisContainer.classList.remove('card-bis--error', 'card-bis--success');
      }
    }
  });

  // ── Swatch arrow navigation ──────────────────────────────────────────────

  function initSwatchArrows(container) {
    var track = container.querySelector('.baslide__track');
    var arrowsEl = container.querySelector('.baslide__arrows');
    if (!track || !arrowsEl) return;
    if (arrowsEl.dataset.arrowsReady) return;
    if (track.getBoundingClientRect().width === 0) return;
    if (track.scrollWidth <= track.clientWidth) return;

    arrowsEl.dataset.arrowsReady = 'true';

    var prevBtn = document.createElement('button');
    var nextBtn = document.createElement('button');
    prevBtn.className = 'baslide__arrow baslide__arrow--prev';
    nextBtn.className = 'baslide__arrow baslide__arrow--next';
    prevBtn.innerHTML = '<svg viewBox="0 0 8 14" width="8" height="14"><path d="M7 1L1 7l6 6" stroke="currentColor" stroke-width="1.5" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    nextBtn.innerHTML = '<svg viewBox="0 0 8 14" width="8" height="14"><path d="M1 1l6 6-6 6" stroke="currentColor" stroke-width="1.5" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg>';

    function getItemWidth() {
      var item = track.querySelector('.baslide__item');
      return item ? item.offsetWidth : 106;
    }

    function updateVisibility() {
      var maxScroll = track.scrollWidth - track.clientWidth;
      prevBtn.style.display = track.scrollLeft <= 2 ? 'none' : '';
      nextBtn.style.display = track.scrollLeft >= maxScroll - 2 ? 'none' : '';
    }

    prevBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      track.scrollBy({ left: -getItemWidth() * 3, behavior: 'smooth' });
    });

    nextBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      track.scrollBy({ left: getItemWidth() * 3, behavior: 'smooth' });
    });

    track.addEventListener('scroll', updateVisibility, { passive: true });

    arrowsEl.appendChild(prevBtn);
    arrowsEl.appendChild(nextBtn);
    updateVisibility();
  }

  function initAllSwatchArrows() {
    document.querySelectorAll('.product-card__swatches.baslide').forEach(initSwatchArrows);
  }

  // ── Init ─────────────────────────────────────────────────────────────────

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      loadSwatchImages();
      initAllSwatchArrows();
    });
  } else {
    loadSwatchImages();
    initAllSwatchArrows();
  }

  // ✅ FIX — observer con debounce y flag para evitar bucle infinito
  swatchObserver = new MutationObserver(function (mutations) {
    if (swatchRunning) return;

    // Solo actuar si hay nodos nuevos añadidos (infinite scroll, etc.)
    var hasAddedNodes = mutations.some(function (m) {
      return m.addedNodes.length > 0;
    });
    if (!hasAddedNodes) return;

    clearTimeout(swatchDebounce);
    swatchDebounce = setTimeout(function () {
      swatchRunning = true;
      if (document.querySelector('.product-card__swatch__loading')) {
        loadSwatchImages();
      }
      initAllSwatchArrows();
      setTimeout(function () { swatchRunning = false; }, 200);
    }, 150);
  });

  swatchObserver.observe(document.body, { childList: true, subtree: true });

  // ── Card-level Back in Stock ─────────────────────────────────────────────

  var KLAVIYO_PUBLIC_KEY = 'R6TfZT';

  document.addEventListener('click', function (event) {
    var feedback = event.target.closest('.card-bis__feedback.error');
    if (feedback) {
      var bisContainer = feedback.closest('.card-bis');
      if (bisContainer) {
        bisContainer.classList.remove('card-bis--error');
        feedback.textContent = '';
        feedback.className = 'card-bis__feedback';
        var emailInput = bisContainer.querySelector('.card-bis__email');
        if (emailInput) { emailInput.value = ''; emailInput.focus(); }
      }
      return;
    }

    var btn = event.target.closest('.card-bis__btn');
    if (!btn) return;

    var bisContainer = btn.closest('.card-bis');
    if (!bisContainer) return;

    var emailInput = bisContainer.querySelector('.card-bis__email');
    var feedback = bisContainer.querySelector('.card-bis__feedback');
    if (!emailInput || !feedback) return;

    var email = emailInput.value.trim();
    var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!email || !emailRegex.test(email)) {
      feedback.textContent = bisContainer.getAttribute('data-invalid-email') || 'Por favor, introduce un email válido.';
      feedback.className = 'card-bis__feedback error';
      feedback.style.display = '';
      bisContainer.classList.remove('card-bis--success');
      bisContainer.classList.add('card-bis--error');
      emailInput.focus();
      return;
    }

    var variantId = bisContainer.getAttribute('data-variant-id');
    if (!variantId) return;

    var successMsg = bisContainer.getAttribute('data-success') || '¡Listo! Te avisaremos cuando vuelva a estar disponible.';
    var errorMsg = bisContainer.getAttribute('data-error') || 'Ha ocurrido un error. Inténtalo de nuevo.';

    btn.disabled = true;

    fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' + KLAVIYO_PUBLIC_KEY, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
      body: JSON.stringify({
        data: {
          type: 'back-in-stock-subscription',
          attributes: {
            channels: ['EMAIL'],
            profile: { data: { type: 'profile', attributes: { email: email } } }
          },
          relationships: {
            variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + variantId } }
          }
        }
      })
    })
    .then(function (response) {
      if (response.ok || response.status === 202) {
        feedback.textContent = successMsg;
        feedback.className = 'card-bis__feedback success';
        feedback.style.display = '';
        bisContainer.classList.remove('card-bis--error');
        bisContainer.classList.add('card-bis--success');
        emailInput.value = '';
      } else {
        return response.json().then(function (err) {
          throw new Error(
            err && err.errors && err.errors[0] && err.errors[0].detail || 'Error ' + response.status
          );
        });
      }
    })
    .catch(function () {
      feedback.textContent = errorMsg;
      feedback.className = 'card-bis__feedback error';
      feedback.style.display = '';
      bisContainer.classList.remove('card-bis--success');
      bisContainer.classList.add('card-bis--error');
    })
    .finally(function () {
      btn.disabled = false;
    });
  });

})();

// ── Inicialización de carruseles ─────────────────────────────────────────

(function () {
  function initCarousels() {
    if (typeof Swiper === 'undefined') return;

    document.querySelectorAll('product-grid .product-card__carousel:not(.swiper-initialized)').forEach(function (el) {
      new Swiper(el, {
        slidesPerView: 1,
        loop: false,
        navigation: {
          nextEl: el.querySelector('.swiper-button-next'),
          prevEl: el.querySelector('.swiper-button-prev'),
        },
        pagination: {
          el: el.querySelector('.swiper-pagination'),
          clickable: true,
          dynamicBullets: true,
        },
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCarousels);
  } else {
    initCarousels();
  }

  var debounceTimer;
  new MutationObserver(function (mutations) {
    var hasNewNodes = mutations.some(function (m) { return m.addedNodes.length > 0; });
    if (!hasNewNodes) return;

    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(initCarousels, 100);
  }).observe(document.body, { childList: true, subtree: true });
})();
